import {
  fetchGetStateByStateKey,
  fetchPutState,
  GetStateResponse,
} from '@iwoca/lapi-client/edge';
import { cloneDeep, set } from 'lodash';

export async function markSignupAsCompleted({
  stateKey,
}: {
  stateKey: string;
}) {
  const data = await fetchGetStateByStateKey({ stateKey: stateKey! });

  if (!data) {
    throw new Error('Could not get state data');
  }

  const newState = addSignupCompletedToUiState({ state: data! });

  await fetchPutState({ stateKey, body: newState });
}

function addSignupCompletedToUiState({ state }: { state: GetStateResponse }) {
  const newState = cloneDeep(state);
  set(newState, 'data.ui.activeStep.id', 'myAccount');
  return newState;
}
